import React, { useEffect, useState } from 'react'
import { useServiceContext } from '../../root'
import { systemInformationService } from '../../services/systemInformationService'
import { useTranslation } from 'react-i18next'
import Modal from '../Modal'

export interface ModalVersionInfoProps {
  show?: boolean
  onHide?: () => void
  versionDetails: unknown
}

const ModalVersionInfo: React.FC<ModalVersionInfoProps> = ({ show, onHide }) => {
  const { t: translate } = useTranslation()
  const { service, config } = useServiceContext()
  const [serverVersion, setServerVersion] = useState('')
  const [serverBuildVersion, setServerBuildVersion] = useState('')
  const [serverVersionTag, setServerVersionTag] = useState('')
  const [showVersionInFooter, setShowVersionInFooter] = useState<boolean>(
    !!service.persist.getGlobal('showVersionInFooter')
  )

  // Read UI version info from HTML attributes (matches legacy pattern)
  const uiVersion = document.documentElement.getAttribute('version') || '0'
  const uiBuildVersion = document.documentElement.getAttribute('build-version') || '0.0.0'

  useEffect(() => {
    systemInformationService.getServerVersion().then((data) => {
      setServerVersion(data.version)
      setServerBuildVersion(data.build)
      setServerVersionTag(data.versionTag)
    })
  }, [])

  const changeShowVersionInFooter = () => {
    const newValue = !service.persist.getGlobal('showVersionInFooter')
    service.persist.setGlobal('showVersionInFooter', newValue)
    setShowVersionInFooter(newValue)
    window.dispatchEvent(new CustomEvent('showVersionInfoInFooterToggled'))
  }

  const handleClose = () => {
    if (onHide) onHide()
  }

  if (!show) return null

  return (
    <Modal show={show} handleClose={handleClose} size="sm">
      <Modal.Body>
        <button type="button" onClick={handleClose} className="close mt10">
          <span className="mr10" aria-hidden="true">
            X
          </span>
          <span className="sr-only">Close</span>
        </button>
        <div id="ModalHeader" className="pl15 pr15 mb15 mt15" style={{ color: '#333' }}>
          {translate('ABOUT_UI_VERSION')} <span className="versionNumber">{uiVersion}</span> <br />{' '}
          {translate('ABOUT_UI_BUILD')} <span className="buildVersion">{uiBuildVersion} GMT</span>
          <br /> {translate('ABOUT_SERVER_VERSION_TAG')} <span className="versionTag">{serverVersionTag}</span> <br />{' '}
          {translate('ABOUT_SERVER_VERSION')} <span className="versionNumber">{serverVersion}</span>
          <br /> {translate('ABOUT_SERVER_BUILD')} <span className="buildVersion">{serverBuildVersion} GMT</span>
          <div className="row">
            <div className="col-xs-6">
              <div className="form-group checkbox-form-group">
                <input
                  type="checkbox"
                  id="showVersionInFooter1"
                  name="showVersionInFooter1"
                  checked={showVersionInFooter}
                  className="mr5"
                  onChange={changeShowVersionInFooter}
                />
                <label htmlFor="showVersionInFooter1">
                  <div className="chkbc"></div>
                  {translate('ABOUT_SHOW_FOOTER')}
                </label>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ModalVersionInfo
